import Backbone from 'backbone';

const sampleTokens = {
  BRAND_NAME: 'Bite Lab',
  GUEST_EMAIL: 'guest@example.com',
  GUEST_NAME: 'Alex Guest',
  GUEST_FIRST_NAME: 'Alex',
  GUEST_LAST_NAME: 'Guest',
  GUEST_PHONE_NUMBER: '(555) 123-4567',
  LOCATION_NAME: 'Test Pinata',
  LOCATION_PHONE_NUMBER: '(555) 987-6543',
  LOCATION_ADDRESS: '123 Main Street',
  ORG_NAME: 'Bite Lab',
  ORDER_NUMBER: 'A1234',
  ORDER_PICKUP_TIME: 'Oct 19 2026, 12:45 PM',
  ORDER_TOTAL: '$4.40',
  ORDERED_AT: 'Oct 19 2026, 12:34 PM',
  TABLE_NUMBER: '12',
  VEHICLE_DESCRIPTION: 'Blue sedan',
};

app.ReceiptSampleView = Backbone.View.extend({
  className: 'receipt-live-preview',

  initialize(options) {
    this.fieldGroupView = options.fieldGroupView;
  },

  value(field) {
    return this.fieldGroupView.getValueForFieldName(field);
  },

  bindImages() {
    this.stopListening();
    ['receiptHeaderImage', 'receiptFooterImage'].forEach((field) => {
      const imageViews = this.fieldGroupView.fieldViewsByField[field]?.imageViews || [];
      imageViews.forEach((imageView) => {
        if (imageView.imagePreview) {
          this.listenTo(imageView.imagePreview, 'receipt-image-rendered', this.render);
        }
      });
    });
  },

  appendTemplate($paper, value) {
    if (!value) {
      return;
    }
    const $block = $('<div class="receipt-live-template"></div>');
    const template = String(value).replace(/{{\s*([A-Z_]+)\s*}}/g, (match, key) => {
      return sampleTokens[key] ?? '';
    });
    const document = new DOMParser().parseFromString(template, 'text/html');
    const appendNode = (node, $parent) => {
      if (node.nodeType === Node.TEXT_NODE) {
        $parent.append(document.createTextNode(node.textContent));
        return;
      }
      if (node.nodeType !== Node.ELEMENT_NODE) {
        return;
      }
      const tag = node.nodeName.toLowerCase();
      if (tag === 'br') {
        $parent.append('<br>');
        return;
      }
      if (tag === 'qrcode') {
        $parent.append($('<span class="receipt-live-code"></span>').text('QR code'));
        return;
      }
      const $target = ['b', 'strong', 's1', 's2', 's3'].includes(tag)
        ? $('<span></span>').addClass(`receipt-live-${tag}`)
        : $parent;
      Array.from(node.childNodes).forEach((child) => appendNode(child, $target));
      if ($target !== $parent) {
        $parent.append($target);
      } else if (['p', 'div'].includes(tag)) {
        $parent.append('<br>');
      }
    };
    Array.from(document.body.childNodes).forEach((node) => appendNode(node, $block));
    $paper.append($block);
  },

  appendImage($paper, field) {
    const imageViews = this.fieldGroupView.fieldViewsByField[field]?.imageViews || [];
    const preview = imageViews.find((imageView) => imageView.getImage())?.imagePreview;
    if (!preview) {
      return;
    }
    const $source = preview.$el.find('canvas, .receipt-preview-fallback').first();
    if (!$source.length) {
      return;
    }
    const $image = $('<div class="receipt-live-image"></div>');
    if ($source.is('canvas')) {
      const source = $source[0];
      const canvas = document.createElement('canvas');
      canvas.width = source.width;
      canvas.height = source.height;
      canvas.getContext('2d')?.drawImage(source, 0, 0);
      $image.append(canvas);
    } else {
      $image.append($source.clone());
    }
    $paper.append($image);
  },

  appendRow($paper, label, amount, className = '') {
    $paper.append(
      $('<div class="receipt-live-row"></div>')
        .addClass(className)
        .append($('<span></span>').text(label), $('<span></span>').text(amount)),
    );
  },

  render() {
    const $paper = $('<div class="receipt-live-paper"></div>');
    const headerText = this.value('receiptHeaderText');
    if (headerText) {
      this.appendTemplate($paper, headerText);
    } else {
      $paper.append(
        $('<div class="receipt-live-brand"></div>').text('Bite Lab'),
        $('<div class="receipt-live-location"></div>').text('Test Pinata'),
      );
    }
    this.appendImage($paper, 'receiptHeaderImage');
    $paper.append(
      $('<div class="receipt-live-order"></div>').text('Oct 19 2026, 12:34 PM'),
      $('<div class="receipt-live-order"></div>').text('To Go  ·  Order A1234'),
    );
    $paper.append(
      $('<div class="receipt-live-vendor"></div>')
        .addClass(`receipt-live-vendor-${this.value('vendorInstructionsSize') || 'large'}`)
        .text('Pickup at counter'),
    );
    const $body = $('<div class="receipt-live-body"></div>').toggleClass(
      'receipt-live-medium',
      this.value('guestReceiptBodyTextSize') === 'medium',
    );
    this.appendRow(
      $body,
      `1 × Sample item${this.value('printOrderedItemPluWithOrderedItems') ? '  [12345]' : ''}`,
      '$4.00',
    );
    this.appendRow(
      $body,
      `  + ${this.value('printModCodes') ? 'TOP  ' : ''}Extra topping`,
      '$1.00',
    );
    if (this.value('printDefaultMods') && this.value('printZeroDollarMods')) {
      this.appendRow($body, '  + Included topping', '$0.00');
    }
    if (this.value('printZeroDollarMods')) {
      this.appendRow($body, '  + Free topping', '$0.00');
    }
    if (this.value('printDeselectedMods')) {
      this.appendRow($body, '  − No onions', '');
    }
    this.appendRow($body, 'Subtotal', '$5.00', 'receipt-live-rule');
    this.appendRow($body, this.value('hideCouponCodes') ? 'Coupon' : 'WELCOME10 coupon', '−$1.00');
    if (this.value('includeTaxTotalOnReceipts')) {
      this.appendRow($body, 'Tax', '$0.40');
    }
    this.appendRow($body, 'Total', '$4.40', 'receipt-live-total');
    $paper.append($body);
    if (this.value('printOrderNumberBarcode')) {
      $paper.append(
        $('<div class="receipt-live-code"></div>').text(
          this.value('printQRCodeWithPosOrderID') ? 'POS order QR code' : 'Order barcode',
        ),
      );
    }
    if (this.value('orderedItemPlusQrCodeConfig')) {
      $paper.append($('<div class="receipt-live-code"></div>').text('Item PLU QR code'));
    }
    if (this.value('printTransactionReceiptText')) {
      $paper.append(
        $('<div class="receipt-live-payment"></div>').text('Card payment  ·  Approved'),
      );
    }
    this.appendTemplate($paper, this.value('receiptFooterText'));
    this.appendImage($paper, 'receiptFooterImage');
    $paper.append($('<div class="receipt-live-powered"></div>').text('Kiosks Powered by Bite'));
    this.$el
      .empty()
      .append(
        $('<h3></h3>').text('Printed kiosk receipt preview'),
        $('<p></p>').text(
          'Sample order data. Layout and optional details vary by printer and integration.',
        ),
        $paper,
      );
    return this;
  },
});
